// removed by extract-text-webpack-plugin
module.exports = {"carousel":"carousel__3Xvwo","controller-wrapper":"controller-wrapper__1cBo9"};


//////////////////
// WEBPACK FOOTER
// ./components/raffle/styles/RaffleCarousel.scss
// module id = I8Wd
// module chunks = 1